<script setup lang="ts">
import { useSiteAlerts } from "@/api/alert-query";
import AlertHistory from "@/components/alert/AlertsHistory.vue";
import AlertsSummary from "@/components/alert/AlertsSummary.vue";
import AlertImportDialog from "@/components/alert/dialogs/AlertImportDialog.vue";
import CreateAlertDialog from "@/components/dialogs/CreateAlertDialog.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const id = computed(() => route.params.id as string);
const importAlerts = ref(false);
function openImportAlerts() {
	importAlerts.value = true;
}

const { data: alerts } = useSiteAlerts(id);

const createDialog = ref(false);

const router = useRouter();

const editAlert = (alertId: string) => {
	router.push({
		name: "sites-id-alerts-alertid",
		params: { id: id.value, alertid: alertId },
		query: route.query,
	});
};
</script>

<template>
	<div class="flex flex-col gap-2">
		<AlertsSummary
			:alerts="alerts || []"
			@click:create="createDialog = true"
			@click:edit="editAlert"
			@click:import="openImportAlerts"
		/>
		<AlertHistory :id="id" />
		<AlertImportDialog v-model:open="importAlerts" :siteId="id" />
		<CreateAlertDialog v-model:dialog="createDialog" @created="editAlert" />
	</div>
</template>
